import axios from "@/lib/axios";

const getCustomer = (custCode: string | undefined) => {
  return axios.get(`/facility/flat_rates/customers/${custCode}`);
}

export default getCustomer;